export const BREAKPOINTS = {
    MOBILE: 575,
    TABLET: 991,
    LAPTOP: 1069,
    DESKTOP: 1199,
} as const;
